export const SDK_VERSION = '7.8.1';
